import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "Задание выполнено: [название]" — sent by the backend's
 * QuestManager::grantReward() when a quest's progress reaches its target.
 * Subject is the recipient themselves (see QuestCompletedBlueprint's
 * docblock); links to the recipient's own Arena tab, same as
 * LevelUpNotification.
 */
export default class QuestCompletedNotification extends Notification {
  icon() {
    return 'fas fa-tasks';
  }
  href() {
    const user = app.session.user;
    return user ? app.route('user.arena', {
      username: user.username()
    }) : '#';
  }
  content() {
    const content = this.attrs.notification.content() || {};
    return app.translator.trans('forumaker-arena.forum.notifications.quest_completed_text', {
      title: String(content.title ?? ''),
      tokens: String(content.rewardTokens ?? 0)
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/QuestCompletedNotification', QuestCompletedNotification);